export enum Access {
  ALL = -1,
  GESTIONNAIRE = 0, //RW
  REDACTEUR = 1, //RW
  LECTURESEULE = 2, //R
  AUCUNACCESS = 3 //N
}
